<template>
  <div :style="'display: flex; max-width:'+fullWidth+'px'">
    <template v-for="(p,i) in percentages">
      <div :key="'shapes_'+i"
           :style="{position: 'relative', 'width': fullWidth/100*p+'px', overflow: 'hidden', display:'inline-block', height: $vuetify.breakpoint.smAndUp ? '136px' : '130px'}">
        <fin-shapes-collection :fill="fill[i]"
                               :stroke="stroke[i]"
                               :full-width="fullWidth"
                               :percentage="100"
                               :style="{position: 'absolute', top: '0', left: offsets[i]}"/>
      </div>
    </template>
  </div>
</template>

<script>
import FinShapesCollection from '@/components/common/shapes/Collection/index'
import AssetClasses from "@/mocks/AssetClasses"

export default {
  name: 'finMultiShapesCollection',
  components: { FinShapesCollection },
  data () {
    return {
      width: 428
    }
  },
  props: {
    /** the color the shapes collection is getting filled with */
    fill: {
      type: Array,
      default () {
        return [
          AssetClasses.items.find(item => item.id === 'SHARE').color,
          AssetClasses.items.find(item => item.id === 'SHARE_ETF').color,
          AssetClasses.items.find(item => item.id === 'CORPORATE_BONDS_ETF').color,
          AssetClasses.items.find(item => item.id === 'GOVERNMENT_BONDS_ETF').color,
          AssetClasses.items.find(item => item.id === 'COMMODITIES_ETF').color
        ]
      }
    },
      /** the color of the borders of the shapes */
      stroke: {
          type: Array,
          default() {
            return [
              AssetClasses.items.find(item => item.id === 'SHARE').color,
              AssetClasses.items.find(item => item.id === 'SHARE_ETF').color,
              AssetClasses.items.find(item => item.id === 'CORPORATE_BONDS_ETF').color,
              AssetClasses.items.find(item => item.id === 'GOVERNMENT_BONDS_ETF').color,
              AssetClasses.items.find(item => item.id === 'COMMODITIES_ETF').color
            ]
          }
      },
    percentages: {
      type: Array,
      default: () => [40, 10, 20, 20, 10]
    },
    fullWidth: {
      type: Number,
      default: 857 /* original svg width */
    }
  },
  computed: {
    offsets () {
      let sum = 0
      return this.percentages.map((item) => {
        const result = sum
        sum += this.fullWidth / 100 * item
        return -result + 'px'
      })
    }
  }
}
</script>

<style scoped>

</style>
